export const appSettings = {
    BaseUrl: process.env.VUE_APP_FOYS_AU_TOURNAMENT_API_BASE_URL,
    AccommodationBaseUrl: process.env.VUE_APP_FOYS_ACCOMMODATION_API_BASE_URL,
    FederationId: process.env.VUE_APP_FEDERATION_ID
};